import React from "react";
import Skeleton from "react-loading-skeleton";
import ProductCard from "../../../../product/components/common/ProductCard";

// --- START MODIFICATION ---
interface FeaturedProductsSkeletonProps {
  title?: string;
}

const FeaturedProductsSkeleton: React.FC<FeaturedProductsSkeletonProps> = ({
  title,
}) => {
  return (
    <section className="featured-products-section">
      <h2 className="section-title">
        {/* Display title if available, otherwise show skeleton */}
        {title ? title : <Skeleton width={250} height={30} />}
      </h2>
      {/* --- END MODIFICATION --- */}

      {/* --- Skeleton for the swiper layout --- */}
      <div className="swiper-container-wrapper">
        <div className="products-grid">
          {[...Array(4)].map((_, index) => (
            <ProductCard.Skeleton key={index} />
          ))}
        </div>

        {/* Skeleton for pagination */}
        <div className="swiper-pagination-skeleton">
          <Skeleton
            circle
            height={12}
            width={12}
            count={4}
            inline={true}
            style={{ margin: "0 4px" }}
          />
        </div>
      </div>

      <div className="section-footer">
        <Skeleton width={150} height={40} />
      </div>
    </section>
  );
};

export default FeaturedProductsSkeleton;
